import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";

function MessageModal({ t, modalShow, messageText, callbackModal, id = "", title = "", buttonText = t("Ok.label"), secondaryButtonText = '', copiableText = false }) {
  const [show, setShow] = useState(modalShow);
  const [message, setMessage] = useState(messageText);

  const handleClose = () => {
    setShow(false);
    callbackModal(false, id);
  }
  const handleButton = () => {
    setShow(false);
    callbackModal(true, id);
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(message);
		toast.info('Copied');
  };

  return (
    <>
      <Modal show={show} onHide={handleButton}
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Modal.Header closeButton>
          <Modal.Title as="h5">{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            copiableText
            ?
            <>
             <pre className="mb-0 text-center h2"><code>{message}</code></pre>
            </>
            : message
          }
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleButton} className="px-4" autoFocus>
            {buttonText} 
          </Button>
          {
            copiableText && 
            <Button variant="secondary" onClick={() => copyToClipboard()} className="px-4">
              {secondaryButtonText} 
            </Button>
          }
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default withTranslation()(MessageModal);
